import './PriceInfo.css'

export default function PriceInfo() {
  return (
    <div className='PriceInfo-container'>
      <div className='PriceInfo-title-section'>
        <h2 className='PriceInfo-title'>PRICE</h2>
      </div>

      <div className='PriceInfo-content-section'>
        <div className='PriceInfo-column'>
          <h3 className='PriceInfo-column-title'>DROP OFF</h3>
          <div className='PriceInfo-minimum-charge'>
            <p>Minimum charge of 20 lbs or $40 for all items below:</p>
          </div>

          <div className='PriceInfo-service-group'>
            <h4 className='PriceInfo-service-header'>24 hour turnaround</h4>
            <ul className='PriceInfo-price-list'>
              <li>Wash/Dry $1.75/lb*</li>
              <li>Wash/Dry - Soiled, Oily or Extra Dirty $2.30/lb*</li>
              <li>Wash/Dry/Fold $2.25/lb*</li>
              <li>Wash/Dry/Fold - Soiled, Oily or Extra Dirty $3.65/lb*</li>
            </ul>
          </div>

          <div className='PriceInfo-service-group'>
            <h4 className='PriceInfo-service-header'>8-10 hour turnaround (Rush)</h4>
            <ul className='PriceInfo-price-list'>
              <li>Wash/Dry $2.25/lb*</li>
              <li>Wash/Dry - Soiled, Oily or Extra Dirty $3.00/lb*</li>
            </ul>
          </div>
        </div>

        <div className='PriceInfo-column'>
          <h3 className='PriceInfo-column-title'>PICKUP&DELIVERY</h3>
          <div className='PriceInfo-minimum-charge'>
            <p>Minimum charge of 20 lbs or $40 for all items below:</p>
          </div>

          <div className='PriceInfo-service-group'>
            <ul className='PriceInfo-price-list'>
              <li>Wash/Dry/Fold $3.00/lb*</li>
              <li>Wash/Dry/Fold - Soiled, Oily or Extra Dirty $4.00/lb*</li>
            </ul>
          </div>

          <div className='PriceInfo-service-group'>
            <p className='PriceInfo-special-item'>
              Hang Dry Items (charged per piece (not included in your total weight)) $2.00/pc.
            </p>
          </div>

          <div className='PriceInfo-disclaimer'>
            <p>
              *Over-sized Items are NOT included in drop off weight and are charged per item i.e. throws, blankets,
              comforters, sleeping bags, pillows, rugs, dog beds, mattress pads etc.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
